var cov_e2zu5ov8r = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Tfoot.tsx",
      hash = "1bee945c1d6dcea015cbe595d8d2e9a716b8353a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Tfoot.tsx",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 27
        },
        end: {
          line: 9,
          column: 37
        }
      },
      "1": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 12,
          column: 5
        }
      },
      "2": {
        start: {
          line: 11,
          column: 6
        },
        end: {
          line: 11,
          column: 42
        }
      },
      "3": {
        start: {
          line: 13,
          column: 21
        },
        end: {
          line: 13,
          column: 47
        }
      },
      "4": {
        start: {
          line: 14,
          column: 16
        },
        end: {
          line: 14,
          column: 18
        }
      },
      "5": {
        start: {
          line: 15,
          column: 4
        },
        end: {
          line: 25,
          column: 5
        }
      },
      "6": {
        start: {
          line: 16,
          column: 18
        },
        end: {
          line: 16,
          column: 29
        }
      },
      "7": {
        start: {
          line: 17,
          column: 6
        },
        end: {
          line: 17,
          column: 32
        }
      },
      "8": {
        start: {
          line: 18,
          column: 18
        },
        end: {
          line: 18,
          column: 19
        }
      },
      "9": {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 24,
          column: 7
        }
      },
      "10": {
        start: {
          line: 20,
          column: 21
        },
        end: {
          line: 20,
          column: 27
        }
      },
      "11": {
        start: {
          line: 21,
          column: 26
        },
        end: {
          line: 21,
          column: 53
        }
      },
      "12": {
        start: {
          line: 22,
          column: 8
        },
        end: {
          line: 22,
          column: 47
        }
      },
      "13": {
        start: {
          line: 23,
          column: 8
        },
        end: {
          line: 23,
          column: 25
        }
      },
      "14": {
        start: {
          line: 26,
          column: 4
        },
        end: {
          line: 26,
          column: 14
        }
      },
      "15": {
        start: {
          line: 30,
          column: 36
        },
        end: {
          line: 30,
          column: 40
        }
      },
      "16": {
        start: {
          line: 31,
          column: 24
        },
        end: {
          line: 31,
          column: 34
        }
      },
      "17": {
        start: {
          line: 32,
          column: 20
        },
        end: {
          line: 32,
          column: 28
        }
      },
      "18": {
        start: {
          line: 33,
          column: 30
        },
        end: {
          line: 33,
          column: 32
        }
      },
      "19": {
        start: {
          line: 34,
          column: 19
        },
        end: {
          line: 34,
          column: 60
        }
      },
      "20": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 46,
          column: 5
        }
      },
      "21": {
        start: {
          line: 36,
          column: 18
        },
        end: {
          line: 36,
          column: 42
        }
      },
      "22": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 39,
          column: 7
        }
      },
      "23": {
        start: {
          line: 38,
          column: 8
        },
        end: {
          line: 38,
          column: 42
        }
      },
      "24": {
        start: {
          line: 40,
          column: 6
        },
        end: {
          line: 42,
          column: 7
        }
      },
      "25": {
        start: {
          line: 41,
          column: 8
        },
        end: {
          line: 41,
          column: 35
        }
      },
      "26": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 45,
          column: 7
        }
      },
      "27": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 34
        }
      },
      "28": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "29": {
        start: {
          line: 56,
          column: 16
        },
        end: {
          line: 56,
          column: 29
        }
      },
      "30": {
        start: {
          line: 57,
          column: 4
        },
        end: {
          line: 65,
          column: 5
        }
      },
      "31": {
        start: {
          line: 60,
          column: 10
        },
        end: {
          line: 62,
          column: 15
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        loc: {
          start: {
            line: 8,
            column: 11
          },
          end: {
            line: 27,
            column: 3
          }
        },
        line: 8
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 29,
            column: 2
          },
          end: {
            line: 29,
            column: 3
          }
        },
        loc: {
          start: {
            line: 29,
            column: 45
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 29
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 55,
            column: 2
          },
          end: {
            line: 55,
            column: 3
          }
        },
        loc: {
          start: {
            line: 55,
            column: 11
          },
          end: {
            line: 66,
            column: 3
          }
        },
        line: 55
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 59,
            column: 17
          },
          end: {
            line: 59,
            column: 18
          }
        },
        loc: {
          start: {
            line: 60,
            column: 10
          },
          end: {
            line: 62,
            column: 15
          }
        },
        line: 60
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 9,
            column: 10
          },
          end: {
            line: 9,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 9,
            column: 20
          },
          end: {
            line: 9,
            column: 22
          }
        }],
        line: 9
      },
      "1": {
        loc: {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 12,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 12,
            column: 5
          }
        }, {
          start: {
            line: 10,
            column: 4
          },
          end: {
            line: 12,
            column: 5
          }
        }],
        line: 10
      },
      "2": {
        loc: {
          start: {
            line: 21,
            column: 35
          },
          end: {
            line: 21,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 35
          },
          end: {
            line: 21,
            column: 47
          }
        }, {
          start: {
            line: 21,
            column: 51
          },
          end: {
            line: 21,
            column: 52
          }
        }],
        line: 21
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 20
          },
          end: {
            line: 30,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 30,
            column: 30
          },
          end: {
            line: 30,
            column: 31
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 18
          },
          end: {
            line: 36,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 18
          },
          end: {
            line: 36,
            column: 36
          }
        }, {
          start: {
            line: 36,
            column: 40
          },
          end: {
            line: 36,
            column: 42
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        }, {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 39,
            column: 7
          }
        }],
        line: 37
      },
      "6": {
        loc: {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 42,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 42,
            column: 7
          }
        }, {
          start: {
            line: 40,
            column: 6
          },
          end: {
            line: 42,
            column: 7
          }
        }],
        line: 40
      },
      "7": {
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }, {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }],
        line: 43
      },
      "8": {
        loc: {
          start: {
            line: 49,
            column: 85
          },
          end: {
            line: 49,
            column: 116
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 85
          },
          end: {
            line: 49,
            column: 91
          }
        }, {
          start: {
            line: 49,
            column: 95
          },
          end: {
            line: 49,
            column: 116
          }
        }],
        line: 49
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Table/Tfoot.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { tableClass } from './styles';
import { isArray } from '../utils/is';

var Tfoot =
/*#__PURE__*/
function (_ref) {
  _inherits(Tfoot, _ref);

  var _super = _createSuper2(Tfoot);

  function Tfoot() {
    _classCallCheck(this, Tfoot);

    return _super.apply(this, arguments);
  }

  _createClass(Tfoot, [{
    key: "getTrs",
    value: function getTrs() {
      cov_e2zu5ov8r.f[0]++;

      var _ref2 = (cov_e2zu5ov8r.s[0]++, this.props),
          _ref2$summary = _ref2.summary,
          summary = _ref2$summary === void 0 ? (cov_e2zu5ov8r.b[0][0]++, []) : _ref2$summary;

      cov_e2zu5ov8r.s[1]++;

      if (!isArray(summary[0])) {
        cov_e2zu5ov8r.b[1][0]++;
        cov_e2zu5ov8r.s[2]++;
        summary = [summary];
      } else {
        cov_e2zu5ov8r.b[1][1]++;
      }

      var summarys = (cov_e2zu5ov8r.s[3]++, summary);
      var trs = (cov_e2zu5ov8r.s[4]++, []);
      cov_e2zu5ov8r.s[5]++;

      for (var i = 0; i < summarys.length; i++) {
        var row = (cov_e2zu5ov8r.s[6]++, summarys[i]);
        cov_e2zu5ov8r.s[7]++;
        trs[i] = [];
        var index = (cov_e2zu5ov8r.s[8]++, 0);
        cov_e2zu5ov8r.s[9]++;

        for (var j = 0; j < row.length; j++) {
          var item = (cov_e2zu5ov8r.s[10]++, row[j]);
          var nextIndex = (cov_e2zu5ov8r.s[11]++, index + ((cov_e2zu5ov8r.b[2][0]++, item.colSpan) || (cov_e2zu5ov8r.b[2][1]++, 1)));
          cov_e2zu5ov8r.s[12]++;
          trs[i].push(this.renderTd(item, index));
          cov_e2zu5ov8r.s[13]++;
          index = nextIndex;
        }
      }

      cov_e2zu5ov8r.s[14]++;
      return trs;
    }
  }, {
    key: "renderTd",
    value: function renderTd(item, index) {
      cov_e2zu5ov8r.f[1]++;

      var _ref3 = (cov_e2zu5ov8r.s[15]++, item),
          render = _ref3.render,
          _ref3$colSpan = _ref3.colSpan,
          colSpan = _ref3$colSpan === void 0 ? (cov_e2zu5ov8r.b[3][0]++, 1) : _ref3$colSpan;

      var _ref4 = (cov_e2zu5ov8r.s[16]++, this.props),
          columns = _ref4.columns;

      var content = (cov_e2zu5ov8r.s[17]++, render());
      var fixed = (cov_e2zu5ov8r.s[18]++, {});
      var isLast = (cov_e2zu5ov8r.s[19]++, index + colSpan - 1 >= columns.length - 1);
      cov_e2zu5ov8r.s[20]++;

      for (var i = 0; i < colSpan; i++) {
        var col = (cov_e2zu5ov8r.s[21]++, (cov_e2zu5ov8r.b[4][0]++, columns[index + i]) || (cov_e2zu5ov8r.b[4][1]++, {}));
        cov_e2zu5ov8r.s[22]++;

        if (col.fixed) {
          cov_e2zu5ov8r.b[5][0]++;
          cov_e2zu5ov8r.s[23]++;
          fixed["fixed-".concat(col.fixed)] = true;
        } else {
          cov_e2zu5ov8r.b[5][1]++;
        }

        cov_e2zu5ov8r.s[24]++;

        if (col.firstFixed) {
          cov_e2zu5ov8r.b[6][0]++;
          cov_e2zu5ov8r.s[25]++;
          fixed['fixed-first'] = true;
        } else {
          cov_e2zu5ov8r.b[6][1]++;
        }

        cov_e2zu5ov8r.s[26]++;

        if (col.lastFixed) {
          cov_e2zu5ov8r.b[7][0]++;
          cov_e2zu5ov8r.s[27]++;
          fixed['fixed-last'] = true;
        } else {
          cov_e2zu5ov8r.b[7][1]++;
        }
      }

      cov_e2zu5ov8r.s[28]++;
      return (
        /*#__PURE__*/
        React.createElement("td", {
          key: index,
          colSpan: colSpan,
          className: tableClass.apply(void 0, _toConsumableArray(Object.keys(fixed)).concat([(cov_e2zu5ov8r.b[8][0]++, isLast) && (cov_e2zu5ov8r.b[8][1]++, 'ignore-right-border')])),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 49,
            columnNumber: 7
          }
        }, content)
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      cov_e2zu5ov8r.f[2]++;
      var trs = (cov_e2zu5ov8r.s[29]++, this.getTrs());
      cov_e2zu5ov8r.s[30]++;
      return (
        /*#__PURE__*/
        React.createElement("tfoot", {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 58,
            columnNumber: 7
          }
        }, trs.map(function (tr, index) {
          cov_e2zu5ov8r.f[3]++;
          cov_e2zu5ov8r.s[31]++;
          return (
            /*#__PURE__*/
            React.createElement("tr", {
              key: index,
              className: tableClass('normal'),
              __self: _this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 60,
                columnNumber: 11
              }
            }, tr)
          );
        }))
      );
    }
  }]);

  return Tfoot;
}((React.PureComponent));

export default Tfoot;